import type { OperatorsName } from "@/stores/operator-store"


export const operators = [
    {
      "id": 1,
      "name": "mci",
      "title": "همراه اول",
      "status": 1
    },
    {
      "id": 2,
      "name": "irancell",
      "title": "ایرانسل",
      "status": 1
    },
    {
      "id": 3,
      "name": "rightel",
      "title": "رایتل",
      "status": 1
    },
    {
      "id": 4,
      "name": "aptel",
      "title": "آپتل",
      "status": 1
    },
    {
      "id": 5,
      "name": "shatel",
      "title": "شاتل",
      "status": 1
    }
  ]

  type IOperatorSettings = Record<
    OperatorsName,
    Partial<Record<
      keyof typeof OperatorSettings,
      string
    >>
  >

  export const operatorSettings: IOperatorSettings  = {
    irancell : {
        credit_cell_direct_charge: 'شارژ اعتباری',
        credit_cell_internet: 'بسته اینترنت اعتباری',
        credit_cell_internet_direct_charge: 'شارژ مستقیم اعتباری اینترنت',
        credit_td_lte_internet: 'بسته اعتباری TD-LTE',
  permanent_cell_direct_charge: 'قبض',
  bill: 'استعلام قبض',
  permanent_cell_internet_direct_charge: 'شارژ مستقیم دائمی اینترنت',
  permanent_td_lte_internet: 'بسته دائمی TD-LET',
  permanent_cell_internet: 'بسته اینترنت دائمی',
    },
    mci : {
        credit_cell_direct_charge: 'شارژ',
        credit_cell_internet: 'بسته اینترنت',
    },
    shatel : {
        credit_cell_direct_charge: 'شارژ',
        credit_cell_internet: 'بسته اینترنت',
    },
    aptel: {
        credit_cell_direct_charge: 'شارژ اعتباری',
        credit_cell_internet: 'بسته اینترنت اعتباری',
        permanent_cell_direct_charge: 'قبض',
        permanent_cell_internet: 'بسته اینترنت دائمی',
    },
    rightel: {
        credit_cell_direct_charge: 'شارژ اعتباری',
        credit_cell_internet: 'بسته اینترنت اعتباری',
        permanent_cell_internet: 'بسته اینترنت دائمی',
    },
    "td-lte": {

    }
}

export enum OperatorSettings {
  credit_cell_direct_charge= 'شارژ اعتباری',
        credit_cell_internet= 'بسته اینترنت اعتباری',
        credit_cell_internet_direct_charge= 'شارژ مستقیم اعتباری اینترنت',
        credit_td_lte_internet= 'بسته اعتباری TD-LTE',
  permanent_cell_direct_charge= 'قبض',
  permanent_cell_internet_direct_charge= 'شارژ مستقیم دائمی اینترنت',
  permanent_td_lte_internet= 'بسته دائمی TD-LET',
  permanent_cell_internet= 'بسته اینترنت دائمی',
  bill = 'استعلام قبض'
  }

export type OperatorSettingsType = keyof typeof OperatorSettings

export  const bgOperatorColors = {
    irancell: 'bg-irancell-primary/60',
    rightel: 'bg-rightel-primary/60',
    mci: 'bg-mci-primary/60',
    shatel: 'bg-shatel-primary/60',
    aptel: 'bg-aptel-primary/60',
    'td-lte': 'bg-irancell-primary/60',
  }

  export  const textOperatorColors = {
    irancell: 'text-irancell-secondary',
    rightel: 'text-rightel-secondary',
    mci: 'text-mci-secondary',
    shatel: 'text-shatel-secondary',
    aptel: 'text-aptel-secondary',
    'td-lte': 'text-irancell-secondary',
  }
